export const SHOW_USER_INFO_MODAL = 'userInfoModal/SHOW_USER_INFO_MODAL';
export const HIDE_USER_INFO_MODAL = 'userInfoModal/HIDE_USER_INFO_MODAL';
export const SHOW_SUCCESS_MESSAGE_MODAL =
  'userInfoModal/SHOW_SUCCESS_MESSAGE_MODAL';
export const HIDE_SUCCESS_MESSAGE_MODAL =
  'userInfoModal/HIDE_SUCCESS_MESSAGE_MODAL';
